import React from 'react'
import { Dropdown, Menu, Icon } from 'semantic-ui-react'
import {navigate , Link, useStaticQuery, graphql} from 'gatsby'
import * as styles from './styles/menu.module.css'

const NavMenu = ({location, token}) => {
	const MenuTemp = useStaticQuery(graphql`
		query MenuQuery {
			menu {
				result {
					name
					url
					children {
						squareImageHref
						name
						url
					}
				}
			}
		}
	`)


	const HomeMenuList = [
		{
			"name": "Home",
			"url": "",
			"children": []
		}
	]
	const AccountMenuList = [
		{
			"name": "Orders",
			"url": "my-account/orders",
			"children": [
				{
					"name": "History",
					"url": "my-account/orders",
					"children": []
				},
				{
					"name": "Submit Payment",
					"url": "payment",
					"children": []
				},
				{
					"name": "Confirm / Approve",
					"url": "my-account/orders?list=confirm",
					"children": []
				},
			]
		},
		{
			"name": "Payment History",
			"url": "my-account/payments",
			"children": []
		}
	];
	const GuestMenuList = [
		{
			"name": "Orders",
			"url": "confirm",
			"children": [
				{
					"name": "Confirm",
					"url": "confirm",
					"children": []
				},
				{
					"name": "Payment",
					"url": "payment",
					"children": []
				},
			]
		},
	];

	const TopMenuList = [
		{
			"name": "Franchise / Distributorship",
			"url": "franchise",
			"children": []
		},
		{
			"name": "Product List",
			"url": "product-list",
			"children": []
		}
	];

	const EndMenuList = [
		{
			"name": "Category List",
			"url": "category",
			"children": []
		},
		{
			"name": "Negosyo",
			"url": "business",
			"children": []
		},
		{
			"name": "Seminars and Courses",
			"url": "seminar",
			"children": [
				{
					"name": "Seminars",
					"url": "seminar",
					"children": []
				},
				{
					"name": "Courses",
					"url": "course",
					"children": []
				},
			]
		},
		{
			"name": "Recipes, Videos and Guides",
			"url": "recipes",
			"children": [
				{
					"name": "Recipes",
					"url": "recipes",
					"children": []
				},
				{
					"name": "Stories and Tips",
					"url": "stories",
					"children": []
				},
				{
					"name": "How-To Guides",
					"url": "howto",
					"children": []
				}
			]
		},
		{
			"name": "FAQs",
			"url": "faq",
			"children": [
				{
					"name": "FAQ",
					"url": "faq",
					"children": []
				},
				{
					"name": "Start Selling",
					"url": "seller",
					"children": []
				},
				{
					"name": "List your Franchise",
					"url": "franchisor",
					"children": []
				}
			]
		},
	];



	const MakeMenuContent = (item, index, obj) => {
		if(item.children) {
			return (
				<React.Fragment key={item.name}>
					{item.children.length > 0 ? (
						<Dropdown.Item
							//need this for the outer edge of the menu categories to also redirect
							onClick={()=>{
								navigate(`/${item.url}`)
							}}
						>
							<Dropdown
								trigger={
									<Link to={`/${item.url}`} className={`${styles.link} ${styles.indentProductCategory}`}>
										<span>{item.name}</span> <Icon name="angle down" />
									</Link>
								}
								//need this for clicking on the parts where it it is triggering the on hover submenu pop up to also redirect
								onClick={()=>{
									navigate(`/${item.url}`)
								}}
								simple
								icon=""
								fluid
							>
								<Dropdown.Menu
									className={styles.subMenu}
									onClick={(event) => {
										event.stopPropagation()
										/*
											added stopPropagation so that event won't
											bubble up when you clicked anywhere on the
											dropdown of a category
										*/
									}}
									direction={"left"}
								>

									{item.children.map(MakeMenuContent)}
								</Dropdown.Menu>
							</Dropdown>
						</Dropdown.Item>
					) : (
						<Dropdown.Item

							as={Link}
							to={item.url.length > 0?`/${item.url}`:"/"}
							key={item.name}

						>
							<span className={styles.indentProductCategory}>{item.name} </span>
						</Dropdown.Item>
					)}
				</React.Fragment>

			)
		}
		else {
			return (
				<Menu.Item

					as={Link}
					to={`/${item.url}`}
					key={item.name}
				>
					{item.name}
				</Menu.Item>
			)
		}

	}



	const menu= MenuTemp.menu.result


	const result = HomeMenuList.concat(token?AccountMenuList:GuestMenuList).concat(TopMenuList).concat(menu).concat(EndMenuList).map(MakeMenuContent)
	return (
		<Menu secondary>
			<Dropdown
				className={` item ${styles.mainMenu}`}
				icon="bars"
			>
				<Dropdown.Menu className={styles.menu}>
					{result}
				</Dropdown.Menu>
			</Dropdown>
		</Menu>
	)
}
export default NavMenu

/*
https://react.semantic-ui.com/modules/dropdown/#types-pointing
*/

